import React from 'react';

const RatingElement = (props) => {
  const range = Array.from(Array(parseInt(props.rating || 0, 10)).keys());

  return (
    <div className='dynamic-report-item'>
      <div className='label' style={{whiteSpace: 'pre-wrap'}}>
        {props.prompt}
      </div>
      <div className='field rating-field'>
        {range && range.map(r => <i key={r} className='fa fa-star' />)}
      </div>
    </div>
  );
};

export default RatingElement;
